import { render, staticRenderFns } from "./MultipleRelationsMenu.vue?vue&type=template&id=310aa708&scoped=true&"
import script from "./MultipleRelationsMenu.vue?vue&type=script&lang=js&"
export * from "./MultipleRelationsMenu.vue?vue&type=script&lang=js&"
import style0 from "./MultipleRelationsMenu.vue?vue&type=style&index=0&id=310aa708&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310aa708",
  null
  
)

export default component.exports